export const verifyCertificateToken = (token) => async (dispatch) => {
  const BASE_URL = process.env.REACT_APP_BASE_URL;

  const getApi = async (url) => {
    const jwt = localStorage.getItem("jwtToken");

    const response = await fetch(`${BASE_URL}${url}`, {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        ...(jwt && { Authorization: `Bearer ${jwt}` }),
      },
    });

    const data = await response.json().catch(() => ({}));

    if (!response.ok) {
      throw new Error(data.message || "API Error");
    }

    return data;
  };

  try {
    dispatch({ type: "CERT_VERIFY_REQUEST" });

    const data = await getApi(
      `/api/v1/certificates/shared/${token}/info`
    );

    dispatch({
      type: "CERT_VERIFY_SUCCESS",
      payload: data,
    });
  } catch (err) {
    dispatch({
      type: "CERT_VERIFY_FAIL",
      payload: err.message,
    });
  }
};